import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCards from "./ProjectCards";
import Particle from "../Particle";
import ProjectModal from "./ProjectModal"; // Import the new modal component

import drum from "../../Assets/Projects/drumkit.jpeg";
import secret from "../../Assets/Projects/secrets.jpeg";
import amazon from "../../Assets/Projects/amazon.jpeg";
import bloggery from "../../Assets/Projects/bloggery.jpeg";
import todos from "../../Assets/Projects/taco-tasks.jpg";
import netflix from "../../Assets/Projects/netflix.png";
import skillwave from "../../Assets/Projects/skillwave.jpg";
import ims from "../../Assets/Projects/taco_inventories.png";
import trader from "../../Assets/Projects/trader.png";

import task1 from "../../Assets/Projects/tacotasks/1.jpg";
import task2 from "../../Assets/Projects/tacotasks/2.jpg";
import task3 from "../../Assets/Projects/tacotasks/3.jpg";
import task4 from "../../Assets/Projects/tacotasks/4.jpg";
import task5 from "../../Assets/Projects/tacotasks/5.jpg";
import task6 from "../../Assets/Projects/tacotasks/6.jpg";
import task7 from "../../Assets/Projects/tacotasks/7.jpg";
import task8 from "../../Assets/Projects/tacotasks/8.jpg";
import task9 from "../../Assets/Projects/tacotasks/9.jpg";

import ims1 from "../../Assets/Projects/tacoims/1.png";
import ims2 from "../../Assets/Projects/tacoims/2.png";
import ims3 from "../../Assets/Projects/tacoims/3.png";
import ims4 from "../../Assets/Projects/tacoims/4.png";
import ims5 from "../../Assets/Projects/tacoims/5.png";
import ims6 from "../../Assets/Projects/tacoims/6.png";
import ims7 from "../../Assets/Projects/tacoims/7.png";
import ims8 from "../../Assets/Projects/tacoims/8.png";

import netflix1 from "../../Assets/Projects/netflix/1.png";
import netflix2 from "../../Assets/Projects/netflix/2.png";
import netflix3 from "../../Assets/Projects/netflix/3.jpeg";

import skill1 from "../../Assets/Projects/skillwave/1.jpg";
import skill2 from "../../Assets/Projects/skillwave/2.jpg";
import skill3 from "../../Assets/Projects/skillwave/3.jpg";
import skill4 from "../../Assets/Projects/skillwave/4.jpg";
import skill5 from "../../Assets/Projects/skillwave/5.jpg";
import skill6 from "../../Assets/Projects/skillwave/6.jpg";
import skill7 from "../../Assets/Projects/skillwave/7.jpg";
import skill8 from "../../Assets/Projects/skillwave/8.jpg";

import amazon1 from "../../Assets/Projects/amazon/1.png";
import amazon2 from "../../Assets/Projects/amazon/2.png";
import amazon3 from "../../Assets/Projects/amazon/3.png";
import amazon4 from "../../Assets/Projects/amazon/4.png";
import amazon5 from "../../Assets/Projects/amazon/5.png";
import amazon6 from "../../Assets/Projects/amazon/6.png";
import amazon7 from "../../Assets/Projects/amazon/7.png";

import creative1 from "../../Assets/Projects/tacocreatives/taco1.png";
import creative2 from "../../Assets/Projects/tacocreatives/taco2.png";
import creative3 from "../../Assets/Projects/tacocreatives/taco3.png";
import creative4 from "../../Assets/Projects/tacocreatives/taco4.png";

function Projects() {
  const [modalShow, setModalShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      imgPath: creative1,
      title: "Taco Creatives | A Company Portfolio Website",
      description:
        "A company portfolio website designed to showcase the services and projects of Taco Creatives, a software solution. This project was developed using Next.js, featuring a clean, modern design that highlights the companys's creative work and services.",
      ghLink: "#",
      demoLink: "https://tacocreatives.vercel.app/",
      images: [creative1, creative2, creative3, creative4],
    },
    {
      imgPath: todos,
      title: "Taco Tasks | A Task Managment Web App",
      description:
        "A simple, user-friendly to-do list web application designed to help users manage their daily tasks efficiently. This project was developed using Next.js, featuring a clean, intuitive interface that allows users to add, edit, delete and archive tasks with ease.",
      ghLink: "https://github.com/fitiha/tacotasks.git",
      demoLink: "https://tacotasks.vercel.app/",
      images: [task1, task2, task3, task4, task5, task6, task7, task8, task9],
    },
    {
      imgPath: ims,
      title: "Taco IMS | Inventory Management System",
      description:
        "A web application that allows stock owners to manage their inventory, track sales, shipments, and generate reports. This project was developed using the React.js with shadcn featuring Tailwind. It features a user-friendly interface that simplifies the inventory management process.",
      ghLink: "#",
      demoLink: "https://tacoims.vercel.app",
      images: [ims1, ims2, ims3, ims4, ims5, ims6, ims7, ims8],
    },
    {
      imgPath: skillwave,
      title: "Skillwave",
      description:
        "I developed the backend of this Learning platform during my 3 months internship program at Dynamic Technologies. The platform is designed to provide a seamless learning experience for students and teachers, with features such as course creation, student enrollment, and progress tracking. The backend was developed using Node.js, Express.js, and MySql.",
      ghLink: "#",
      demoLink: "#",
      images: [skill1, skill2, skill3, skill4, skill5, skill6, skill7, skill8],
    },
    {
      imgPath: bloggery,
      title: "Bloggery V-1.0",
      description:
        "Bloggery is a minified social media for making blogs having categorized blog posts, AI chatbot, responsive design and user interactions [commenting, following, and liking] enhanced by Redux.",
      demoLink: "https://bloggery.vercel.app/",
      images: [bloggery],
    },
    {
      imgPath: trader,
      title: "CMarket",
      description:
        "A platform to show market values of items on different places to make an informed decision on buying or selling.",
      ghLink: "#",
      demoLink: "#",
      images: [trader],
    },
    {
      imgPath: netflix,
      title: "Netflix-clone",
      description:
        "A fully responsive Netflix clone using React, designed to mirror the aesthetic and functionality of the original Netflix platform. This dynamic web application features a user-friendly interface that showcases a collection of movies in a visually appealing, scrollable format similar to Netflix's own design.",
      ghLink: "https://github.com/fitiha/Netflix-clone.git",
      demoLink: "https://netflix-clone-taupe-eight.vercel.app/",
      images: [netflix1, netflix2, netflix3],
    },
    {
      imgPath: amazon,
      title: "Amazon-clone",
      description:
        "A clone of Amazon, one of the world's leading e-commerce platforms. It is designed to replicate key features of the original site, providing a robust demonstration of my full-stack development skills.",
      ghLink: "https://github.com/fitiha/Amazon-clone.git",
      demoLink: "https://amazon-clone-hazel-eight.vercel.app/",
      images: [amazon1, amazon2, amazon3, amazon4, amazon5, amazon6, amazon7],
    },
    {
      imgPath: drum,
      title: "Drum Kit",
      description:
        "This project is a straightforward, user-friendly virtual drum allowing a user to have the experience of the basic drum beats using the touch pad or keyboard as preferred.",
      ghLink: "https://github.com/fitiha/drum-kit",
      demoLink: "http://nattyfish.42web.io/",
      images: [drum],
    },
    {
      imgPath: secret,
      title: "Adey Secrets",
      description:
        "A secure, anonymous platform where individuals can freely express themselves and share their secrets without fear of exposure or backlash. This not only helps in alleviating personal burdens but also fosters a sense of community and mutual support among users. Through this website, users find relief and a renewed sense of connection, knowing they are not alone in their experiences.",
      ghLink: "https://github.com/fitiha/TodolistApp.git",
      demoLink: "https://adeysecrets.onrender.com",
      images: [secret],
    },
  ];

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setModalShow(true);
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCards
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
                onClick={() => handleProjectClick(project)}
              />
            </Col>
          ))}
        </Row>
      </Container>

      {selectedProject && (
        <ProjectModal
          show={modalShow}
          handleClose={() => setModalShow(false)}
          images={selectedProject.images}
          title={selectedProject.title}
          description={selectedProject.description}
          ghLink={selectedProject.ghLink}
          demoLink={selectedProject.demoLink}
        />
      )}
    </Container>
  );
}

export default Projects;
